import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const env = import.meta.env;

export const firebaseApp = initializeApp({
  apiKey: env.VITE_FIREBASE_API_KEY,
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: env.VITE_FIREBASE_APP_ID,
});

export const auth = getAuth(firebaseApp);
auth.languageCode = 'ar';

export const db = initializeFirestore(firebaseApp, { ignoreUndefinedProperties: true });

export const functions = getFunctions(firebaseApp, 'europe-west1');

/** Public base URL of the R2 image domain (img. subdomain). */
export const IMG_BASE_URL = env.VITE_IMG_BASE_URL ?? '';
